import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Clock, Star } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contacto" className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-dark border-t border-riam-gold/10" data-id="element-6">
      <div className="container mx-auto px-4 md:px-6" data-id="element-7">
        <SectionHeading title={t.contact.title} data-id="element-8" />

        <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto mt-16" data-id="element-9">
          {/* Info */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/3 space-y-8" data-id="element-10">
            <div className="flex items-start space-x-4" data-id="element-11">
              <MapPin className="icon-glow flex-shrink-0 mt-1" size={24} stroke="url(#riamGold)" data-id="element-12" />
              <div data-id="element-13">
                <h4 className="font-script font-semibold text-2xl text-riam-gold mb-1" data-id="element-14">
                  {t.contact.addressTitle}
                </h4>
                <p className="font-sans text-riam-gold-light/80" data-id="element-15">
                  40-17 48th Ave
                  <br data-id="element-16" />
                  Sunnyside, NY 11104
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4" data-id="element-17">
              <Phone className="icon-glow flex-shrink-0 mt-1" size={24} stroke="url(#riamGold)" data-id="element-18" />
              <div data-id="element-19">
                <h4 className="font-script font-semibold text-2xl text-riam-gold mb-1" data-id="element-20">
                  {t.contact.phoneTitle}
                </h4>
                <a href="tel:+19299794936" className="font-sans text-riam-gold-light/80 hover:text-riam-gold transition-colors" data-id="element-21">
                  (929) 979-4936
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4" data-id="element-22">
              <Clock className="icon-glow flex-shrink-0 mt-1" size={24} stroke="url(#riamGold)" data-id="element-23" />
              <div data-id="element-24">
                <h4 className="font-script font-semibold text-2xl text-riam-gold mb-1" data-id="element-25">
                  {t.contact.hoursTitle}
                </h4>
                <p className="font-sans text-riam-gold-light/80 whitespace-pre-line" data-id="element-26">
                  {t.contact.hoursDesc}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4" data-id="element-27">
              <Star className="icon-glow flex-shrink-0 mt-1" size={24} stroke="url(#riamGold)" fill="url(#riamGoldFill)" data-id="element-28" />
              <div data-id="element-29">
                <h4 className="font-script font-semibold text-2xl text-riam-gold mb-1" data-id="element-30">
                  {t.contact.reviewsTitle}
                </h4>
                <p className="font-sans text-riam-gold-light/80" data-id="element-31">
                  4.8 ★ Google (93+)
                  <br data-id="element-32" />
                  5.0 ★ Booksy (94+)
                </p>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-2/3 h-[400px] border border-riam-gold/20 rounded-sm overflow-hidden" data-id="element-33">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.136893665313!2d-73.9238356!3d40.7370399!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25f2b8b9b8b9b%3A0x8b9b8b9b8b9b8b9b!2s40-17%2048th%20Ave%2C%20Sunnyside%2C%20NY%2011104!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={false} loading="lazy" title="Riam Beauty Studio Location" data-id="element-34"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}